import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { type AbstractControl, type ValidatorFn, Validators } from '@angular/forms';

@Pipe({
  name: 'hasRequiredValidator',
  pure: false,
})
export class HasRequiredValidatorPipe implements PipeTransform {
  /**
   *
   * @param value
   * @param _unusedJustRefresh If the validator changes dynamically, this is the notification thread that the validators have changed.
   */
  transform(value: AbstractControl, _unusedJustRefresh?: ValidatorFn | null): boolean {
    return value.hasValidator(Validators.required);
  }
}
